import { v1ApiClient } from '@/services';
import type {
  Operation,
  OperationRequestBody,
  Schema,
} from '@/shared/api/generated';

type UpdateAggregatedReportFolderOperation =
  Operation<'UpdateAggregatedReportFolder'>;

export type UpdateAggregatedReportFolderParams =
  UpdateAggregatedReportFolderOperation['parameters']['path'] &
    OperationRequestBody<'UpdateAggregatedReportFolder'>;

export type UpdateAggregatedReportFolderResponse =
  Schema<'AggregatedReportFolder'>;

export const updateAggregatedReportFolder = ({
  workspace_id,
  folder_id,
  ...body
}: UpdateAggregatedReportFolderParams): Promise<UpdateAggregatedReportFolderResponse> =>
  v1ApiClient
    .patch(
      `/workspaces/${workspace_id}/aggregated-report-folders/${folder_id}`,
      body,
    )
    .then((res) => res.data);
